import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Import to initialize i18next
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement // This is TypeScript syntax
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// ...
reportWebVitals();
